import { type FC } from 'react'
import UserList from './UserList'
import { useDisabledUsersQuery } from './query'

interface DisabledUserListProps {
  filterInput: string | null
}

const DisabledUserList: FC<DisabledUserListProps> = ({ filterInput }) => {
  const { data: users, isLoading } = useDisabledUsersQuery()

  return (<UserList filterInput={filterInput} users={users} isLoading={isLoading} />)
}

export default DisabledUserList
